import { z } from 'zod';
export const DomainSchema = z
    .hostname()
    .refine((domain) => !domain.endsWith('.'), {
    message: 'Must not end with a trailing dot',
})
    .transform((domain) => domain.toLowerCase())
    .refine((domain) => domain.includes('.'), {
    message: 'Must be a fully qualified domain name (e.g. example.com)',
});
//# sourceMappingURL=domain.js.map